import standardTypes from "./standard.type";

const initialState = {
  quizSet: [],
  standardCode: null,
  reviewers: [],
  creators: [],
  error: "",
};

export default function standardReducer(state = initialState, action) {
  switch (action.type) {
    case standardTypes.GET_STANDARD_QUIZSET_SUCCESS:
      return { ...state, quizSet: action.payload || [], error: "" };
    case standardTypes.GET_STANDARD_CODE_SUCCESS:
      return {
        ...state,
        standardCode: action.payload || null,
        error: "",
      };
    case standardTypes.GET_STANDARD_REVIEWERS_SUCCESS:
      return { ...state, reviewers: action.payload || [], error: "" };
    case standardTypes.GET_STANDARD_CREATORS_SUCCESS:
      return { ...state, creators: action.payload || [], error: "" };
    case standardTypes.GET_STANDARD_QUIZSET_FAILURE:
    case standardTypes.GET_STANDARD_CODE_FAILURE:
    case standardTypes.GET_STANDARD_REVIEWERS_FAILURE:
    case standardTypes.GET_STANDARD_CREATORS_FAILURE:
      return {
        ...state,
        error: action.error?.message || "An error occurred",
      };

    default:
      return state;
  }
}
